import {
  FETCH_INBOX_CONFIG,
  FETCH_INBOX_CONFIG_SUCCESS,
  FETCH_INBOX_CONFIG_ERROR
} from '../actions/inbox_action'

const initialState = {
  loading: false,
  config: null,
  error: null
}

const inboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INBOX_CONFIG:
      return {
        ...state,
        loading: true,
        error: null
      }
    case FETCH_INBOX_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        config: action.payload,
        error: null
      }
    case FETCH_INBOX_CONFIG_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default inboxReducer
